import { defineMessages } from 'react-intl';

export const sharedExploreOperationsMessages: {
	heading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	primaryAction: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	heading: {
		defaultMessage: 'Explore Operations',
		description:
			'Heading for the spotlight card shown on the Operations sidebar menu item, shared across cohorts that use the Explore Operations CTA',
		id: 'alexstrasza.operations-overview-discoverability-spotlights.shared.explore-operations.heading',
	},
	primaryAction: {
		defaultMessage: 'Explore',
		description:
			'Primary action button on the spotlight card that navigates to Operations, shared across cohorts that use the Explore Operations CTA',
		id: 'alexstrasza.operations-overview-discoverability-spotlights.shared.explore-operations.primary-action',
	},
});

const marketplaceOpsDescriptionMessage = defineMessages({
	description: {
		defaultMessage:
			"You're getting notified through third-party integrations today. Instead, set up operations to receive real-time alerts and stay on top of issues as soon as they happen.",
		description:
			'Description for the spotlight card shown on the Operations sidebar menu item for marketplace ops experiment',
		id: 'alexstrasza.operations-overview-discoverability-spotlights.marketplace-ops.description',
	},
});

export const marketplaceOpsMessages: {
	heading: typeof sharedExploreOperationsMessages.heading;
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	primaryAction: typeof sharedExploreOperationsMessages.primaryAction;
} = {
	heading: sharedExploreOperationsMessages.heading,
	description: marketplaceOpsDescriptionMessage.description,
	primaryAction: sharedExploreOperationsMessages.primaryAction,
};

export const inactiveOpsMessages: {
	heading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	primaryAction: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	heading: {
		defaultMessage: "You're almost there",
		description:
			'Heading for the spotlight card shown on the Operations sidebar menu item for inactive ops experiment',
		id: 'alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.heading',
	},
	description: {
		defaultMessage:
			"It's been a while since you started setting up operations. Turn on alerts and on-call schedules to unlock its full potential for your team.",
		description:
			'Description for the spotlight card shown on the Operations sidebar menu item for inactive ops experiment',
		id: 'alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.description',
	},
	primaryAction: {
		defaultMessage: 'Go to Operations',
		description:
			'Primary action button on the spotlight card for inactive ops experiment that navigates to Operations',
		id: 'alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.primary-action',
	},
});

export const commonTourMessages: {
	step1Heading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	step2Heading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	step2Description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	nextButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	primaryAction: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	stepCount: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	step1Heading: {
		defaultMessage: 'Complete your Operations setup',
		description: 'Heading for step 1 of the spotlight tour targeting the More button',
		id: 'alexstrasza.operations-overview-discoverability-spotlights.tour.step1-heading',
	},
	step2Heading: {
		defaultMessage: "You're almost there",
		description:
			'Heading for step 2 of the spotlight tour targeting Operations inside the More menu',
		id: 'alexstrasza.operations-overview-discoverability-spotlights.tour.step2-heading',
	},
	step2Description: {
		defaultMessage:
			'Click on <b>Operations</b> to set up alerts and on-call schedules to make sure your team stay on top of issues as soon as they happen.',
		description: 'Description for step 2 of the spotlight tour',
		id: 'alexstrasza.operations-overview-discoverability-spotlights.tour.step2-description',
	},
	nextButton: {
		defaultMessage: 'Next',
		description: 'Next button text on the first step of the spotlight tour',
		id: 'alexstrasza.operations-overview-discoverability-spotlights.tour.next-button',
	},
	primaryAction: {
		defaultMessage: 'Go to Operations',
		description: 'Primary action button text on the last step of the spotlight tour',
		id: 'alexstrasza.operations-overview-discoverability-spotlights.tour.primary-action',
	},
	stepCount: {
		defaultMessage: '{currentStep} of {totalSteps}',
		description: 'Step count indicator showing current step position in the spotlight tour',
		id: 'alexstrasza.operations-overview-discoverability-spotlights.tour.step-count',
	},
});

export const marketplaceOpsTourMessages: {
	step1Description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	step1Description: {
		defaultMessage:
			"You're getting notified through third-party integrations today. Click <b>More</b> to set up operations and unlock its full potential for your team.",
		description: 'Description for step 1 of the spotlight tour for marketplace ops experiment',
		id: 'alexstrasza.operations-overview-discoverability-spotlights.marketplace-ops.tour.step1-description',
	},
});

export const inactiveOpsTourMessages: {
	step1Description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	step1Description: {
		defaultMessage:
			"It's been a while since you started setting up operations. Click <b>More</b> to set up operations and unlock its full potential for your team.",
		description: 'Description for step 1 of the spotlight tour for inactive ops experiment',
		id: 'alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.tour.step1-description',
	},
});

const highBugLoadDescriptionMessage = defineMessages({
	description: {
		defaultMessage:
			"Your team's been logging a lot of bugs. Set up operations to get ahead of the next one — with on-call, alerting, and incident response built right in.",
		description:
			'Description for the spotlight card shown on the Operations sidebar menu item for high bug load experiment',
		id: 'alexstrasza.operations-overview-discoverability-spotlights.high-bug.description',
	},
});

export const highBugLoadMessages: {
	heading: typeof sharedExploreOperationsMessages.heading;
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	primaryAction: typeof sharedExploreOperationsMessages.primaryAction;
} = {
	heading: sharedExploreOperationsMessages.heading,
	description: highBugLoadDescriptionMessage.description,
	primaryAction: sharedExploreOperationsMessages.primaryAction,
};

export const highBugLoadTourMessages: {
	step1Description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	step1Description: {
		defaultMessage:
			"Your team's been logging a lot of bugs. Click <b>More</b> to set up operations and get ahead of the next one — with on-call, alerting, and incident response built right in.",
		description: 'Description for step 1 of the spotlight tour for high bug load experiment',
		id: 'alexstrasza.operations-overview-discoverability-spotlights.high-bug.tour.step1-description',
	},
});
